import { defaultVariant } from './variants/default';
import { eligibilityRevampVariant } from './variants/eligibility-revamp';
import type { RoutePath, WizardVariant, WizardVariantDefinition } from './wizard';

export const WIZARD_VARIANTS = {
  default: defaultVariant,
  'eligibility-revamp': eligibilityRevampVariant,
} satisfies Record<string, WizardVariantDefinition>;

export const FALLBACK_WIZARD_VARIANT_ID = 'default' satisfies keyof typeof WIZARD_VARIANTS;

/**
 * Validates that no routes appear in multiple milestones within a variant.
 * This constraint is required because milestones are designed to be uniquely identifiable by their route.
 * @throws Error if duplicate routes are found
 */
function assertUniqueRoutes(variants: Record<string, WizardVariant>): void {
  for (const [variantId, variant] of Object.entries(variants)) {
    if (variant.id !== variantId) {
      throw new Error(`Variant key "${variantId}" does not match variant id "${variant.id}"`);
    }

    const seenRoutes = new Map<RoutePath, string>();

    for (const milestone of variant.milestones) {
      for (const route of milestone.routes) {
        const existingMilestone = seenRoutes.get(route);
        if (existingMilestone) {
          throw new Error(
            `Duplicate route "${route}" in variant "${variantId}": ` +
              `found in both "${existingMilestone}" and "${milestone.id}" milestones`
          );
        }
        seenRoutes.set(route, milestone.id);
      }
    }
  }
}

// Fail fast if configuration is invalid
assertUniqueRoutes(WIZARD_VARIANTS);
